import React from 'react';
import { Image as AntdImage } from 'antd';

const Image = ({ ...props }) => {
    return <AntdImage alt='picture' preview={false} {...props} />;
};

export default Image;
